/**
 * Canonical shared vocabulary. These values MUST match the backend exactly.
 * Do not add display/formatting concerns here — see `vocabulary-display.ts`.
 */

export const VERDICT = {
  PASS: "PASS",
  AUTO_CORRECT: "AUTO_CORRECT",
  PARTIAL_BLOCK: "PARTIAL_BLOCK",
  REDIRECT: "REDIRECT",
  ESCALATE: "ESCALATE",
  BLOCK: "BLOCK",
} as const;
export type Verdict = (typeof VERDICT)[keyof typeof VERDICT];

/**
 * Severity ordering for verdicts, low to high. Used to compare verdicts and
 * to decide the floor for unrecognized values (see forward-compat.ts).
 */
export const VERDICT_SEVERITY_ORDER: readonly Verdict[] = [
  VERDICT.PASS,
  VERDICT.AUTO_CORRECT,
  VERDICT.REDIRECT,
  VERDICT.PARTIAL_BLOCK,
  VERDICT.ESCALATE,
  VERDICT.BLOCK,
];

export const CHECK_RESULT = {
  PASS: "PASS",
  FAIL: "FAIL",
  WARN: "WARN",
  INDETERMINATE: "INDETERMINATE",
} as const;
export type CheckResult = (typeof CHECK_RESULT)[keyof typeof CHECK_RESULT];

export const CONSEQUENCE_TIER = {
  TIER_0: 0,
  TIER_1: 1,
  TIER_2: 2,
  TIER_3: 3,
  TIER_4: 4,
} as const;
export type ConsequenceTier = (typeof CONSEQUENCE_TIER)[keyof typeof CONSEQUENCE_TIER];

export const REVERSIBILITY = {
  REVERSIBLE: "REVERSIBLE",
  COMPENSABLE: "COMPENSABLE",
  IRREVERSIBLE: "IRREVERSIBLE",
} as const;
export type Reversibility = (typeof REVERSIBILITY)[keyof typeof REVERSIBILITY];

export const TRUST_LABEL = {
  TRUSTED_INTERNAL: "TRUSTED_INTERNAL",
  UNTRUSTED_INBOUND: "UNTRUSTED_INBOUND",
} as const;
export type TrustLabel = (typeof TRUST_LABEL)[keyof typeof TRUST_LABEL];

export const ACTION_TYPE = {
  PRIOR_AUTH_SUBMIT: "prior_auth.submit",
  CLAIM_SUBMIT: "claim.submit",
  RX_DISPENSE: "rx.dispense",
  RX_TRANSMIT: "rx.transmit",
  CHART_WRITE: "chart.write",
  FAX_SEND: "fax.send",
  MESSAGE_PATIENT: "message.patient",
  APPOINTMENT_BOOK: "appointment.book",
  ELIGIBILITY_CHECK: "eligibility.check",
  REFUND_ISSUE: "refund.issue",
} as const;
export type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];
